<template>
  <div v-loading="loading" :class="showUploadDailog ? 'device-plan-library-dialog' : ''">
    <div>
      <div class="video_action">
        <op-action-container :web-container="webContainer" :action-list="handleActionList" :show-mode="showMode">
          <template #action="{ item }">
            <control-item
              :action-info="item.actionInfo"
              :show-button="false"
              :is-i-f-t-t="true"
              :is-detail="true"
              :device-card-list="deviceCardList"
              :PlanId="PlanId"
              :only-scene-no-list="onlySceneNoList"
              :is-edit-video-scene="isEditVideoScene"
              :device-model="model"
              :selected-scene-no="selectedSceneNo"
              :show-mode="showMode"
              @do-call-action-middle="
                (...arg) => {
                  doCallActionClassSku(item.actionInfo, ...arg)
                }
              "
              @do-call-action-video=" (...arg) => {
                doCallActionClassSkuVideo(...arg)
              }"              
            />
          </template>
        </op-action-container>
      </div>
    </div>
  </div>
</template>

<script>
import { alerterror, alertsuccess } from '@/assets/js/common.js'
import { CallAction } from '@/axios/IDevice.js'
import TianmuProxy from '@/page/tianmu-design/canvas/CanvasMain/lib/TianmuProxy'
import OpActionContainer from '@/components/common/layer/OpActionContainer.vue'
import controlItem from '@/components/common/controlItem'
import { PLANSTATUS } from './constants'
import { APP_SHOW_MODE_ENUM } from '@/utils/enums'
import { ActionVo } from '@/utils/actionsHandler';

const PlaybackSpeed =  ["UIControl_TianMu_PlaybackSpeed_Group","UIControl_TianMu_PlaybackSpeed"]

const Loop = [ "UIControl_TianMu_Loop_Group","UIControl_TianMu_Loop"]

export default {
  components: {
    OpActionContainer,
    controlItem,
  },
  props: {
    model: {
      type: Object,
      default: () => ({}),
    },
    deviceCardList: {
      type: Array,
      default: () => [],
    },
    PlanId: {
      type: String,
      default: '',
    },
    webContainer: {
      type: Object,
      default: () => null,
    },
    actionList: {
      type: Array,
      default: () => [],
    },
    showMode: {
      type: Number,
      default: 0,
    },
    
    isEditVideoScene:{
      type:Boolean,
      default:true
    },
    onlySceneNoList: {
      type: Boolean,
      default: false
    },
    selectedSceneNo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      PLANSTATUS,
      showUploadDailog: false,
      videoUrl: '',
      cdnUrl: '',
      planName: '',
      loading: false,
      LibraryList: [],
      isEdit: false,
      refreshTimer: null,
      videoDuration: 0,
      videoCurrentTime: 0,
      isSeeking: false,
      wasPlaying: false,
      isPlaying: false,
      fileInfo: null,
      videoThumbnail: null, //视频封面的缩略图.自己截取的是格式是base64
      videoThumbnailURL: null, //接口请求后，返回回来的url地址
      connection: null, // 网络连接对象
      isConnectionSupported: false, // 浏览器是否支持网络连接API
    }
  },
  computed: {
     handleActionList(){
       this.actionList.forEach(item => {
        const Values = item?.Values
        Values.forEach(tem=>{
          if(tem.IsShow &&  PlaybackSpeed.includes(tem.ValueType)){
            const DefaultValue = JSON.parse(getLocalStoragItem("tianmuPlaySpeedAndLoop"))?.[this.model.VDeviceId]?.playSpeed
            tem.DefaultValue = (DefaultValue || 10) / 10
          }
          if(tem.IsShow && Loop.includes(tem.ValueType) ){
            const DefaultValue = JSON.parse(getLocalStoragItem("tianmuPlaySpeedAndLoop"))?.[this.model.VDeviceId]?.loop
            tem.DefaultValue = DefaultValue ?? 1
          }
        })
      })

      return this.actionList
     }
  },
  methods: {
  //   // 设备控制方法
    doCallActionClassSku(tem, info, model, _type, color, value) {
      console.log("🚀 ~ doCallActionClassSku ~ tem:", tem)
      if (tem.UI?.NoneNeedCallAction) return
      this.doCallAction(tem)
    },
    
    //控制视频播放
    doCallActionClassSkuVideo(item){
       console.log("🚀 ~ doCallActionClassSkuVideo ~ item:", item)
       this.doCallAction(item)
    },

    async doCallAction(item, ref) {
      debugger
      let playVideo = false
      if(item.UI != null &&item.UI.NoneNeedCallAction == true){
        return
      }
     // let _values = ''
      let valueList = [];
      let callNext = true
      item.Values.forEach((tem) => {

        /* SDL灯带含有颜色的需要拥有颜色才能下发其他action，251925264为能力表默认值 */
        if(tem.ValueType === 'UIControl_CXCY_Color_Multiple_Choose'  && (tem.DefaultValue == '251925264' || tem.DefaultValue == '0')){
          callNext = false
        }

        if(tem.ValueType === "UIControl_TianMu_Video_Group"){
          playVideo = true
        }

        let Value = ''

       const isPlaybackSpeed =
          tem?.IsShow &&
          PlaybackSpeed.includes(tem.ValueType)

        if (isPlaybackSpeed) {
          Value = tem.DefaultValue * 10
        } else {
          const submitData = typeof tem?.getSubmitData === 'function'
            ? tem.getSubmitData()
            : ActionVo.getSubmitData(tem)

          Value = submitData?.Value
        }


        const deviceId = this.model.VDeviceId;

        // 1. 从 localStorage 获取已有数据（如果有）
        let existingData = getLocalStoragItem("tianmuPlaySpeedAndLoop");

        try {
          existingData = existingData ? JSON.parse(existingData) : {};
        } catch (e) {
          existingData = {};
        }

         //本地记住倍速和循环
       if((tem.IsShow) && PlaybackSpeed.includes(tem.ValueType)){

          const newData = {
            playSpeed: Value, 
          };

            // 2. 更新当前设备的数据
        existingData[deviceId] = {
          ...existingData[deviceId], 
          ...newData              
        };
          setLocalStoragItem("tianmuPlaySpeedAndLoop", JSON.stringify(existingData))
       }

       if((tem.IsShow) && Loop.includes(tem.ValueType)){
          const newData = {
            loop: Value, 
          };
           // 2. 更新当前设备的数据
        existingData[deviceId] = {
          ...existingData[deviceId], 
          ...newData             
        };
          setLocalStoragItem("tianmuPlaySpeedAndLoop", JSON.stringify(existingData))
       }

        valueList.push(Value);
      })


      if(playVideo){
        const [ChannelId, Object_ID, , , FadeTime] = valueList
        let PlaySpeedDefaultValue = 0
        let LoopDefaultValue = 0
        //获取倍速和循环的默认值
        
        this.actionList.forEach(item=>{
          const Values =  item?.ActionList&&item?.ActionList.length>0 ? item?.ActionList[0]?.Values : item?.Values

          
          Values.forEach(tem=>{
            if (tem.IsShow && tem.ValueType === 'UIControl_TianMu_PlaybackSpeed') {
               //const { Value } = tem?.getSubmitData();
               PlaySpeedDefaultValue = tem.DefaultValue * 10
            }

            if (tem.IsShow && tem.ValueType === 'UIControl_TianMu_PlaybackSpeed_Group' && this.showMode === APP_SHOW_MODE_ENUM.IFTTT) {
               //const { Value } = ActionVo?.getSubmitData(tem);
               PlaySpeedDefaultValue = tem.DefaultValue * 10
            }
            if (tem.IsShow &&  tem.ValueType === 'UIControl_TianMu_Loop') {
               //const { Value } = tem?.getSubmitData();
               LoopDefaultValue = tem.DefaultValue
            }

            if (tem.IsShow && tem.ValueType === 'UIControl_TianMu_Loop_Group' && this.showMode === APP_SHOW_MODE_ENUM.IFTTT) {
               //const { Value } = ActionVo?.getSubmitData(tem);
               LoopDefaultValue = tem.DefaultValue
            }
          })
        })

        valueList = [ChannelId, Object_ID, PlaySpeedDefaultValue, LoopDefaultValue, FadeTime]

      }
   

      
      let para = {
        vDeviceId: this.model.VDeviceId,
        msgType: item.MsgType,
        channelId: this.model.ChildId,
        values: valueList.join(',')
      }


      if(callNext){
        CallAction(para, this.functionDoCallAction)
      }
      //针对于el-slider
      if(ref){
        if(Array.isArray(this.$refs[ref])){
          setTimeout(() => {
            this.$refs[ref][0] && this.$refs[ref][0].$refs["button1"] && this.$refs[ref][0].$refs["button1"].handleMouseLeave()
          }, 500);
        }
      }
    },
     functionDoCallAction(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.device-plan-library {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
}

.addCard ::v-deep .el-upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.uploadDailog {
  width: 100%;
  height: 100%;

  ::v-deep .el-dialog {
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    overflow: scroll;

    .el-dialog__header {
      background: #2145a4;
      border-radius: 8.53px 8.53px 0px 0px;

      .el-dialog__title {
        color: #ffffff;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
      }
    }
  }
}

.uploadDailog_content {
  width: 100%;
  height: 100%;
  //padding: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  flex-direction: column;
  .planImage {
    width: 600px;
    height: 350px;
    object-fit: cover;
  }

  .tips {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    flex-direction: row;

    span {
      color: #3d3d3d;
      font-size: 15px;
    }

    .inputTitle {
      color: #333333;
      font-weight: 600;
      font-size: 13px;
      margin-right: 10px;
    }

    .yellow {
      color: rgba(255, 178, 0, 1);
      font-size: 15px;
      margin-right: 3px;
    }

    .inputPlan {
      width: 360px;
    }
  }

  .inputDiv {
    margin-top: 50px;
  }

  .addBtn {
    margin-top: 80px;
    padding: 0px 64px;
    background: #2145a4;
    border-radius: 6px;
    font-size: 19px;
    color: #fff;
    line-height: 40px;
    height: 40px;
    text-align: center;
    cursor: pointer;
    transition: opacity 0.3s;

    &.disable {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .video_controls {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 600px;
    height: 40px;
    background: rgba(0, 0, 0, 0.3);

    img {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

    .duration {
      color: #fff;
    }

    .progress-bar {
      width: 300px;
      cursor: pointer;
    }
  }
}
</style>
<style>
.dialog-open-global-style .v-modal {
  display: none !important;
}

.dialog-close-global-style .device-plan-library .v-modal {
  display: none !important;
}

.video_action .other_action {
  align-items: center;
}

.video_action .active_joinTool{
  width: 100% !important;
}

/* .video_action .other_action .device_div_action {
  padding-left: 0;
}

.video_action .other_action .device_div_action .scence_ctr_span_title {
  margin-left: 0;
} */
</style>
